<template>
    <div class="headerBg">
      <div class="header" :class="nowActive== '1'&&'headerNow1'">
        <div class="newNav flex">
          <img class="logoImg cursorPoi" @click="changeMenuBtn('1')" :src="nowActive == '1'?require('../../static/images/codeLogo.png'):require('../../static/images/codeLogo.png')">
          <section class="menuView flex alignCenter">
            <div v-for="i in menuList" :key="i.id" class="menu" :class="nowActive == i.id&&'menuActive'" @click="changeMenuBtn(i.id)">{{i.name}}</div>
          </section>
        </div>
        <div class="headerRight">
          <div class="flex alignCenter" v-if="userInfoData.token">
              <!-- 用户头像 -->
            <div class="user-avator">
              <img src="../../static/images/defaut-avator.png">
            </div>
            <!-- 用户名下拉菜单 -->
            <el-dropdown class="user-name" trigger="click" @command="handleCommand">
              <span class="el-dropdown-link tw-flex tw-items-center">
                  {{userInfoData.user.phone}} <img src="../../static/images/bottom-arrow.png" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="userinfoBtn">个人中心</el-dropdown-item>
                <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="flex" v-else>
            <div class="loginBtn linearBtnBg tw-flex tw-justify-center tw-items-center" @click="loginBtn('2')">
              <div class="textBtn">登录</div>
            </div>
          </div>
        </div>
        <!-- 退出确认弹框 -->
        <el-dialog
          append-to-body
          class="quitMsgDialog"
          :visible.sync="quitMsgDialogShow"
          :close-on-click-modal="false"
          width="360px"
          top="calc(50vh - 140.5px)"
          :show-close="false">
              <section class="detailItemView">
                <img class="closeIcon" @click="quitMsgDialogCloseBtn" src="../../static/images/popup-close.png" />
                  <div class="quitMsgDialogContent">
                    <div class="title">确定退出登录？</div>
                    <div class="funBtn tw-flex tw-justify-between">
                      <el-button class="btn cancelBtn" @click="quitMsgDialogCloseBtn">取消</el-button>
                      <el-button class="btn sureBtn linearBtnBg" @click="sureQuitBtn">确定</el-button>
                    </div>
                  </div>
              </section>
        </el-dialog>
      </div>
    </div>
</template>

<script>
import {successMsg} from '../utils/confirm'
import {getCookiesData} from '../utils/common'
export default {
  name: 'headerDiv',
  data () {
    return {
      nowActive: '', // 选中菜单
      userInfoData: {}, // 用户信息
      menuList: [{name: '首页', id: '1'},{name: '文档', id: '2'}],
      quitMsgDialogShow: false // 退出二次确认弹框
    }
  },
  props: {
    nowActivePor: {
      type: String,
      default: ''
    },
  },
  mounted () {
    console.log(process.env.VUE_APP_LOGININURL)
    this.userInfoData = getCookiesData('skyCodeUserBaseInfo')?JSON.parse(getCookiesData('skyCodeUserBaseInfo')): {}
    console.log(this.userInfoData)
    this.nowActive = this.nowActivePor
    console.log(this.nowActivePor)
  },
  // watch的作用是：父组件数据修改后，子组件未变动（修改）
  watch: {
    nowActivePor: {
      immediate: true,
      handler (val) {
        this.nowActive = val
      }
    }
  },
  methods: {
    changeMenuBtn (status) {
      console.log(status)
      if (this.nowActive != status + '') {
          this.nowActive = status + ''
          switch(this.nowActive) {
            case '1':
              this.$router.push('/')
              break;
            case '2':
              this.$router.push('/documentIndex')
              break; 
          }
      }
    },
    childUpdateUserMsgFn () { // 父组件调用我们的方法
      this.userInfoData = getCookiesData('skyCodeUserBaseInfo')?JSON.parse(getCookiesData('skyCodeUserBaseInfo')): {}
      console.log(this.userInfoData)
    },
    loginBtn (status) {
      console.log(status)
      // this.$actionBuryPointWay('','login_popup','右上角弹窗','')
      this.$emit('isShowLoginPopupClick', true, '/')
    },
    handleCommand (command) {
      var that = this
      console.log('click on item ' + command)
      if (command === 'loginOut') {
        that.quitMsgDialogShow = true
      } else {
        // 判断用户是否退出
        if(getCookiesData('skyCodeResearchToken')){
          that.$router.push({path: '/userinfoIndex'})
        }else{
          that.userInfoData.token='', 
          that.$emit('isShowLoginPopupClick', true, '/userinfoIndex')
        }
      }
    },
    quitMsgDialogCloseBtn() {
      this.quitMsgDialogShow = false
    },
    sureQuitBtn() {
      let that = this
      that.$jsonPost(that.$axiosUrl.loginOut, {})
        .then((response) => {
          console.log(response)
          this.$store.dispatch('LoginOut')
          successMsg('成功退出！')
          that.quitMsgDialogShow = false
          window.location.href = process.env.VUE_APP_LOGININURL // 页面会刷新
        })
    }
  }
}
</script>

<style scoped lang="less">
.headerBg {
    position: fixed;
    z-index: 300;
    top: 0;
    width: 100vw;
    height: 117px;
    background-color: #060714;
    // border-bottom: 1px solid rgba(38, 40, 64, 0.5);
}
.headerNow1 {
    background: url('../../static/images/header-bg.png');
    background-size: 100% 100%; 
}
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 117px;
    padding: 0px 80px;
    
    .newNav {
      .logoImg {
        // width:162px;
        // height:36px;
        width: 6.7708vw;
        height: 1.5104vw;
      }
      .menuView {
        margin-left: 19.0625vw;
      }
      .menu {
        margin-right: 39px;
        color: #DCDFFF;
        opacity: 0.6;
        cursor: pointer;
        font-weight: 700;
        font-size: 18px;
        padding-bottom: 8px;
        padding-top: 5px;
        // border-bottom: 2px solid transparent;
      }
      .menuActive {
        opacity: 1;
        // border-bottom: 3px solid #000;
      }
    }
    .headerRight {
      display: flex;
      align-items: center;
      height: 40px;
      color: #000;
      .user-avator {
        img {
          width: 38px;
          height: 38px;
          line-height: 38px;
          margin-right: 12px;
          vertical-align: middle;
        }
      }
      .user-name  {
        cursor: pointer;
        font-weight: 700;
        font-size: 18px;
        color: #F3F5F7;
        img {
          width: 18px;
          height: 12px;
          margin-left: 8px;
        }
      }
      .loginBtn {
          width: 128px;
          height: 51px;
        .textBtn {
          width: 124px;
          height: 47px;
          line-height: 47px;
          font-size: 18px;
          color: #fff;
          text-align: center;
          cursor: pointer;;
          border-radius: 12px;
          background: #060714;
        }
      }
    }
  }
  .quitMsgDialogContent {
    .title {
      margin: 24px 0 64px 0;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      text-align: center;
    }
    .funBtn {
      padding: 0 9px 0 7px;
      .btn {
        padding: 0;
        width: 129px;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-weight: 700;
        font-size: 16px;
        border: none;
        color: #fff;
      }
      .cancelBtn {
        border: 2px solid #7780A1;
        // box-shadow: inset -4px -4px 4px rgba(0, 0, 0, 0.1), inset 4px 4px 4px rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        color: #7780A1;
      }
    }
  }
</style>
<style lang="less">
.el-dropdown-menu {
  border: none;
}
.el-dropdown-menu__item {
  width: 142px;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  color: #fff;
  height: 46px;
  line-height: 46px;
}
.el-dropdown-menu__item:hover {
  color: #fff !important;
  background: linear-gradient(104.42deg, #4745D0 0%, #2A27C9 60.23%) !important;
}
.el-popper {
  width: 144px;
  height: 134px;
  background: linear-gradient(187.96deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0) 93.86%), #060714;
  border: 1px solid #262840;
  border-radius: 8px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
  margin-top: 37px !important;
  padding-top: 18px !important;
}
.popper__arrow {
    top: -24px !important;
    left: 26px !important;
    border-width: 12px !important;
    border-bottom-color: #262840 !important;
}
.popper__arrow::after {
    top: -11px !important;
    margin-left: -12px !important;
    border-width: 12px !important;
    border-bottom-color: #151622 !important;
}


.quitMsgDialog {
    .el-dialog__wrapper {
      background: rgba(0, 0, 0, .6);
    }
    .el-dialog {
      height: 281px;
      background: #FFFFFF;
      border-radius: 16px;
    }
    .closeIcon {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 28px;
        height: 28px;
        cursor: pointer;
    }
}
.el-dialog__body {
    padding: 0 35px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
